/** Shared by Help dialog and excalidraw-app contact modal. */
export const CONTACT_US_OPEN_EVENT = "diagrams-free:open-contact-us";
